export const formatRelativeTime = (dateString, useAgo = true) => {
  if (!dateString) return 'Unknown time';

  const date = parseDisplayDate(dateString);
  if (isNaN(date.getTime())) return 'Unknown time';

  const now = new Date();
  let diffMs = now - date;
  const isFuture = diffMs < 0;

  // For significant future skew, render a relative duration instead of collapsing
  // everything to "just now".
  if (isFuture) {
    diffMs = Math.abs(diffMs);
  }

  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  const suffix = useAgo && !isFuture ? ' ago' : '';

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m${suffix}`;
  if (diffHours < 24) return `${diffHours}h${suffix}`;
  if (diffDays < 7) return `${diffDays}d${suffix}`;
  
  return date.toLocaleDateString();
};

export const formatAbsoluteTime = (dateString) => {
  if (!dateString) return 'Unknown time';

  const date = parseDisplayDate(dateString);
  if (isNaN(date.getTime())) return 'Unknown time';

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const HAS_TIMEZONE_RE = /[Zz]$|[+-]\d{2}(?::?\d{2})?$/;

function parseDisplayDate(dateInput) {
  if (dateInput instanceof Date) return dateInput;
  if (typeof dateInput !== 'string') return new Date(dateInput);

  const raw = dateInput.trim();
  if (!raw) return new Date(NaN);

  // Keep explicit timezone timestamps untouched.
  if (HAS_TIMEZONE_RE.test(raw)) {
    return new Date(raw);
  }

  // Some feed payloads can arrive without timezone. Prefer UTC parsing,
  // but if that lands in the future while local parsing does not, use local.
  const utcCandidate = new Date(`${raw}Z`);
  const localCandidate = new Date(raw);

  if (isNaN(utcCandidate.getTime())) return localCandidate;
  if (isNaN(localCandidate.getTime())) return utcCandidate;

  const now = Date.now();
  const utcFutureSkewMs = utcCandidate.getTime() - now;
  const localFutureSkewMs = localCandidate.getTime() - now;

  if (utcFutureSkewMs > 5 * 60 * 1000 && localFutureSkewMs <= 5 * 60 * 1000) {
    return localCandidate;
  }

  return utcCandidate;
}
